import React from 'react'
import ReactDOM from 'react-dom'

import App from './app'
import registerServiceWorker from './register-service-worker'

ReactDOM.render(<App />, document.getElementById('appMountPoint'))

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js